import * as yup from 'yup';

export const validationSchema = yup.object({
  providerVisibleReviewPeriodEndDate: yup.date().required('Removed from provider view date is required.').typeError(''),
  providerVisibleReviewPeriodStartDate: yup.date().required('Provider view date is required.').typeError(''),
  reviewDate: yup.date().required('Review date is required.').typeError(''),
  reviewTypeId: yup.string().required('Review type is required.'),
});
